import React from 'react'
import { ToggleCardItemsProps, ToggleCardNumberProps } from './ToggleCard.types'

export const ToggleCardWrapper = ({
  classNames = '',
  children,
  id = ''
}: ToggleCardItemsProps) => (
  <div className={`togglecard-wrapper ${classNames}`} id={id}>
    {children}
  </div>
)

export const ToggleCardHeader = ({
  classNames = '',
  children
}: ToggleCardItemsProps) => (
  <div className={`togglecard-header ${classNames}`}>{children}</div>
)

export const ToggleCardContent = ({
  classNames = '',
  children
}: ToggleCardItemsProps) => (
  <div className={`togglecard-content ${classNames}`}>{children}</div>
)

export const ToggleCardNumber = ({ current, max }: ToggleCardNumberProps) => (
  <div className='togglecard-numbers-wrapper'>
    <span className='togglecard-numbers'>{current}</span>
    <span className='togglecard-numbers'>{max}</span>
  </div>
)
